import {
  Factory,
  BriefcaseBusiness,
  Users,
  ChartNoAxesColumnIncreasing,
  House,
  ClipboardList,
  FlaskConical,
  Package,
  FileText,
  Wallet,
  CalendarDays,
  ClipboardCheck,
  Droplets,
  Pill,
  PawPrint,
  SprayCan,
  Flower2,
  Leaf,
  Microscope,
} from 'lucide-react';
export function WorkspaceIcon({ name }: { name: string }) {
  const icons = {
    factory: Factory,
    office: BriefcaseBusiness,
    customers: Users,
    owner: ChartNoAxesColumnIncreasing,
    home: House,
    product: ClipboardList,
    sample: FlaskConical,
    package: Package,
    document: FileText,
    payment: Wallet,
    calendar: CalendarDays,
    review: ClipboardCheck,
    cosmetics: Droplets,
    supplements: Pill,
    'pet-care': PawPrint,
    'home-care': SprayCan,
    'home-fragrance': Flower2,
    'herbal-spa': Leaf,
    'ingredients-extracts': Microscope,
  };
  const Icon = icons[name as keyof typeof icons] ?? ClipboardList;
  return <Icon aria-hidden="true" />;
}
